var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactInfoIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17.259px",
    height: "28.616px",
    viewBox: "0 0 17.259 28.616",
    enableBackground: "new 0 0 17.259 28.616",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#dd6466",
    d: "M14.031,22.958H3.229c-1.27,0-2.305-1.034-2.307-2.304V5.987C0.925,4.717,1.958,3.682,3.229,3.68h10.801 c1.27,0.002,2.303,1.036,2.307,2.306v14.667C16.333,21.926,15.3,22.958,14.031,22.958L14.031,22.958z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B555F",
    d: "M14.031,0H3.229C1.447,0.004,0.003,1.447,0.001,3.229L0,11.384v9.269v0.004v4.731 c0.003,1.781,1.447,3.226,3.229,3.229h10.801c1.781-0.003,3.225-1.447,3.229-3.229l0,0V3.229C17.255,1.447,15.812,0.004,14.031,0z  M3.229,1.846h10.801c0.699,0.002,1.281,0.542,1.365,1.222c-0.414-0.195-0.877-0.309-1.365-0.309L3.229,2.758 C2.74,2.759,2.278,2.871,1.862,3.067C1.946,2.388,2.53,1.848,3.229,1.846z M15.414,25.388c0,0.755-0.629,1.383-1.383,1.384H3.229 c-0.755-0.001-1.383-0.629-1.385-1.384v-1.823c0.42,0.2,0.889,0.316,1.385,0.316h10.801c0.496,0,0.963-0.116,1.383-0.316V25.388z  M15.414,20.652c0,0.755-0.629,1.383-1.383,1.384H3.229c-0.755-0.001-1.383-0.629-1.385-1.384V5.987 c0.002-0.755,0.63-1.383,1.385-1.384h10.801c0.754,0.001,1.383,0.629,1.383,1.384V20.652z M10.419,24.351H6.841 c-0.254,0-0.463,0.207-0.463,0.461v0.924c0,0.254,0.209,0.462,0.463,0.462h3.579c0.254,0,0.461-0.208,0.461-0.462v-0.924 C10.88,24.558,10.673,24.351,10.419,24.351z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfoIcon2);
export default __webpack_public_path__ + "static/media/contact-info-icon2.147f15bd8be4aa6156f5641b032a58da.svg";
export { ForwardRef as ReactComponent };